import React, { useLayoutEffect } from "react";
import { BrookshireBrotherLogoWithTagline, helpingOurOwnBrochure } from "../../../../../assets";
import CoreHelpingOurOwnImage from "../../../../../assets/CorePlanImages/CoreHealpingOurOwnImage.avif";
import "./helpingourown.scss";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";

const HelpingOurOwn: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="Helping-card-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Helping Our Own Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={BrookshireBrotherLogoWithTagline} alt="" />
					</div>
					<div className="plan-description">
						<ul>
							<li>What is Helping Our Own?</li>
							<p>
								It is an employee deduction-funded program that supports our fellow Employee Owners who
								have suffered significant financial hardship due to certain unexpected circumstances.
							</p>
							<li>How is it funded?</li>
							<p>
								The fund enables our Employee Owners to provide support for fellow Employee Owners
								during their time of need. Employee Owners can donate to this fund through payroll
								deduction. All donations further the purposes of the Helping Our Own fund in its mission
								to assist “our own” Brookshire Brothers Employee Owners. Employees can deduct $1 or more
								per week to go towards this fund.{" "}
								<span>If youre interested in making payroll contributions towards Helping Our Own</span>
								, please complete the following form and mail it back to the Human Resources department.
							</p>
						</ul>
					</div>
				</div>
				<div className="right-section">
					<img src={CoreHelpingOurOwnImage} alt="Core Helping our own image" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={helpingOurOwnBrochure} />
			</div>
		</div>
	);
};

export default HelpingOurOwn;
